// extracted by mini-css-extract-plugin
module.exports = {"icons":"icons-homepage_icons__G4Xk6","iconsWidth":"icons-homepage_iconsWidth__3QOgj"};